import '../css/FormTemplate.css';
import '../css/PageTemplate.css';
import '../css/Login.css';
import {  useState, useContext } from 'react';
import { AppContext } from "./context/AppContext";
import axios from 'axios';
import {Buffer} from 'buffer';
import { IConfiguration, ILogInForm, ILoginEMessage, IAuth } from '../interfaces/interface';
import { IMessageErrorResponse } from '../interfaces/messageInterface';

function LoginMedia() {
  const { login, config, authorization, errorHandlerFunction } = useContext(AppContext);
  const [, setIsLogged ] = login;
  const errorHandler: (status: number) => string = errorHandlerFunction
  const [, setAuth ]: React.Dispatch<React.SetStateAction<IAuth>>[] = authorization;
  const [,setConfiguration]:React.Dispatch<React.SetStateAction<IConfiguration>>[] = config;
  const [formInput, setFormInput] = useState<ILogInForm>({
    username: "",
    password: "",
  });
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<ILoginEMessage>({
    displayMessage: false,
    message: ""
  });

  const changeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
    setFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
    setErrorMessage({
      displayMessage: false,
      message: ""
    })
  };

  const LoginUser = (e: any): void => {
    e.preventDefault();
    const formData = `${formInput.username}:${formInput.password}`;
    let buffer = Buffer.from(formData, 'utf-8');
    const base64FormData = buffer.toString('base64');
    
    axios
    .get('/request-token', { 
      headers: {
        Authorization: `Basic ${base64FormData}`
        //,type: "cookie"
      }})
      .then( res =>  {        
        setAuth({
          token: res.data.token,
          expiresOn: res.data.expiresOn,
          scope: res.data.scope,
          header:{
            headers: {
              Authorization: `bearer ${res.data.token}`
            }
          },
          username: formInput.username,
        })
        // ///change for dev
        setIsLogged(true);

        axios.post("/message", {
          type: "getAssociationConfig",
          userId: formInput.username
        },{
            headers: {
              Authorization: `bearer ${res.data.token}`
          }
        }).then(res => { 
          setConfiguration(res.data.configuration);
          
          // ///change for dev

          // if(!res.data.configuration.enableLoadSensor){
          //   console.log("load-sensor-isun");
            
          //   let temp = disableLinks
          //   temp.push("Add-Load-Sensor")
          //   setDisableLinks(temp)
          // }
          setIsLogged(true);
          setErrorMessage({
            displayMessage: false,
            message: ""
          })         
          
        }).catch(({response}:IMessageErrorResponse) => {
          const errorMessage = errorHandler(response.data.status)
          setErrorMessage({
            displayMessage: true,
            message: errorMessage
          })
        })
      }).catch(({response}:IMessageErrorResponse) => {
        const errorMessage = errorHandler(response.data.status)
        setErrorMessage({
          displayMessage: true,
          message: errorMessage
        })
      })

  };

  return (
    <div className="page-template">
        <div className='login-header'>
          <span className="hoopo-logo">
            <img className="hoopo-logo-img" src="/hoopo_logo.jpg" alt='hoopo logo' /> 
          </span>
            <h6 className="hoopo-logo-text">Assets in sight</h6>
            <h2 className='hoopo-header'> Asset Association Tool</h2> 
        </div>
        <form className="login-form" onSubmit={LoginUser}>
            <div className='login-form-top'>
                <div className="form-template-internal-div">
                    <label className="form-template-label">
                        Username
                    </label>
                    <input
                        className="form-template-input"
                        type="text"
                        value={formInput.username}
                        onChange={changeHandler}
                        name="username"
                    />
                </div>
                <div className="form-template-internal-div">
                  <label className="form-template-label">
                    Password
                  </label>
                  <input
                      className="form-template-input"
                      type={isVisible? "text" : "password"}
                      value={formInput.password}
                      onChange={changeHandler}
                      name="password"
                  />
                  <span className="invisible-icon" onClick={()=> setIsVisible(!isVisible)}>
                    <img className="password-icon" src={isVisible? "/icons/show.png" : "/icons/hide.png"} alt='show/hide password' /> 

                  </span>
                </div>
                <div className="login-error-message">
                    {errorMessage.displayMessage &&
                        `${errorMessage.message}`
                    }
                </div>
            </div>
            <button type="submit" className="login-btn">
                Login
            </button>
        </form>
    </div>
  );
}

export default LoginMedia;
